import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link, Stack, Button } from '@mui/material';
// components
import MailTextField from '../../fields/MailTextField';
import PasswordTextField from '../../fields/PasswordTextField';
import ControlledCheckbox from '../../fields/ControlledCheckbox';

// ----------------------------------------------------------------------

export default function LoginForm({ control, onSubmit }) {
  return (
    <>
      <form onSubmit={onSubmit()} className="form">
        <Stack spacing={3}>
          <MailTextField control={control} />
          <PasswordTextField control={control} />
        </Stack>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <ControlledCheckbox control={control} />

          <Link
            component={RouterLink}
            to="/passwort-vergessen"
            variant="subtitle2"
            underline="hover"
          >
            Passwort vergessen?
          </Link>
        </Stack>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="secondary"
          sx={{
            mt: 2,
            mb: 3,
            fontSize: '125%',
          }}
        >
          LOGIN
        </Button>
      </form>
    </>
  );
}

LoginForm.propTypes = {
  control: PropTypes.object,
  onSubmit: PropTypes.func,
};
